<template>
    <div class="form-page" v-if="form != null">
        <div class="container">
            <div class="column-container" :class="{'toManyRequests' : toManySendingMsg}">
                <div class="col-left">
                    <div class="form-titles">
                        <h3>{{form.form_page_title}}</h3>
                        <span>{{form.form_page_desc}}</span>
                    </div>
                </div>
                <div class="col-right">
                    <form class="form_call">
                        <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                            <div class="form-group form-text" :class="{'error' : errors.has('name')}">
                                <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                            </div>
                            <div class="form-group form-phone" :class="{'error' : errors.has('phone')}">
                                <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                            </div>
                            <VueRecaptcha
                                ref="recaptchaFormPage"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                :sitekey="salesGcap_siteKey"
                                size="invisible"
                            />
                            <div class="btn-send">
                                <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_call_btn_desc}}</button>
                                <span class="error-message" v-show="errors.has('name') || errors.has('phone')">Заполните все поля</span>
                            </div>
                            
                        </div>
                        <div class="successMessage" v-if="!formVisible">
                            <h3>Спасибо! Ваша заявка отправлена.</h3>
                        </div>
                    </form>
                </div>
                <div class="privacy-desc" v-if="formVisible">
                    <p>
                        <span>{{ form.form_privacy_desc.one }}</span> 
                        «<span>{{ form.send_call_btn_desc }}</span>» <br>
                        <span class="two">{{ form.form_privacy_desc.two }}</span>
                        <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ form.form_privacy_desc.word }}</a></span>
                        <span class="three">{{ form.form_privacy_desc.three }}</span>
                    </p>
                </div>
                <div class="to-many-requests-msg" v-if="toManySendingMsg">
                    <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                    <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                    <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import { VueRecaptcha } from 'vue-recaptcha';
    import {mapGetters} from 'vuex'
    
    export default {
        name: 'FormConsultLand',
        data () {
            return {
                globalLang: window.GlobalLang, 
                phone: '',
                name: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                toManySendingMsg: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadForms',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('formPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('formPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(submissionCounter)
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'name': this.name,
                    'phone': this.phone,
                };
                this.formVisible = false;
                console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call-sales.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('formPage_submissionCounter', submissionCounter);
                    localStorage.setItem('formPage_lastSubmissionTime', currentMinutes);
                    // console.log(submissionCounter)
                    dataLayer.push({'event' : 'form_sent'})
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            onCaptchaExpired() {
                console.log('capcha expired');
                // Handle expiration
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok');
                        this.$refs.recaptchaFormPage.execute();
                        // var dataForm = {
                        //     "phone": this.phone,
                        //     "email":"",
                        //     "advertisingChannel": "Заявка с сайта",
                        //     "requestWebsite":"soho2.bazis.kz",
                        //     "leadName": this.name,
                        //     "description":"",
                        //     "complex":"SOHO2",
                        //     "utmSource":"sales.bazis.kz",
                        //     "utmMedium":"referral",
                        //     "utmCampaign":"bazis-page"
                        // };
                        // this.$store.dispatch('sendLead_toCRM', dataForm);
                        // this.$refs.recaptchaFormPage.execute();
                        // this.sendInGoogleDoc(data, this.salesCard.city_name_sales.slug);
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            // sendData() {
            //     var querystring = require('querystring');
            //     var urlForm = '/formSendConsult.php';
            //     var data = {
            //         'admin': 'newcrm_bazis@mail.ru',
            //         'name': this.name,
            //         'phone': this.phone,
            //     };
            //     this.$validator.validate().then(result => {
            //         if(result) {
            //             this.formVisible = false
            //             axios.post(urlForm, querystring.stringify(data)).then(() => {
            //                 dataLayer.push({'event' : 'form_sent'})
            //             });
            //         } else {
            //             this.errorMsg = true;
            //             console.log('Form inputs with errors');
            //         }
            //     });
            // },
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-page.scss';
    @import '@/styles/respond/forms/form-page-respond.scss';
    // @import '@/styles/components/forms/forms-respond/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>